<div class="body-container">
  <!--order details-->
  <div class="details-container">
    <div *ngIf="showNewOrderInstr" class="new-order-instr">
      <p>{{ "translate.order.newOrderInstr" | translate }}</p>
    </div>

    <div *ngIf="showRefundInstr" class="new-order-instr">
      <p>{{ "translate.order.refundInstr" | translate }}</p>
    </div>

    <!--items-->
    <order-lines
      [orderId]="currentOrder?.orderId"
      [orderLines]="currentOrder?.orderLines"
      (onSaved)="reloadOrderHeader()"
      [allowEdit]="allowEditLines"
      [displayClosedOrder]="displayClosedOrder"
    ></order-lines>

    <!--stages-->
    <loader *ngIf="activityLogLoading"></loader>
    <activity-log
      *ngIf="displayActivityLog"
      [order]="currentOrder"
    ></activity-log>

    <!--files-->
    <div *ngIf="displayFiles" class="files-container">
      <loader *ngIf="orderHeaderLoading"></loader>

      <order-files
        #custFiles
        *ngIf="displayCustFiles"
        [order]="currentOrder"
        (onFileUploaded)="onFileUploaded()"
        [allowUpload]="allowCustFileUpload"
      ></order-files>

      <order-files
        #rxFiles
        *ngIf="displayRXFiles"
        [order]="currentOrder"
        (onFileUploaded)="onFileUploaded()"
        [isRX]="true"
        [allowUpload]="true"
      ></order-files>
    </div>
  </div>

  <div class="chat-col-container">
    <!--rx gist-->
    <rx-gist
      *ngIf="qcModeSw && currentOrder?.rxGist"
      [rxGist]="currentOrder.rxGist"
    ></rx-gist>

    <!--chat-->
    <div class="chat-container" [class.disabled]="chatDisabled">
      <p *ngIf="chatDisabled" class="disabled-area">
        {{ "translate.order.newOrderDisabledArea" | translate }}
      </p>
      <div class="chat-tab-container">
        <div
          *ngFor="let c of chatTabs"
          class="chat-tab"
          [class.active]="c.contact == (currentChatContact$ | async)"
          (click)="selectChatContact(c.contact)"
          [class.single]="chatTabs.length == 1"
        >
          <h2
            class="t-widgetTitle chat-title"
            [class.has-unread]="c.contact.unreadCnt > 0"
          >
            {{ c.contact.chatTitle | translate }}
          </h2>
          <p
            *ngIf="displayLastSeen && c.contact.lastSeen"
            class="last-seen"
            (mouseenter)="onLastSeenHover(c.contact, $event)"
            (mouseleave)="onLastSeenMouseLeave($event)"
            [style.cursor]="'pointer'"
          >
            {{ "translate.chat.lastSeen" | translate }}
            {{
              c.contact.lastSeen?.toString()
                | niceDateFormatPipe : c.contact.curDbDate
            }}
          </p>
          <hr *ngIf="chatTabs.length == 1" />
        </div>
      </div>

      <!-- Participant Activity Popover -->
      <p-popover
        #participantsPopover
        [dismissable]="true"
        appendTo="body"
        [style]="{ minWidth: '300px' }"
        (onHide)="selectedContact = null"
      >
        <div class="participants-activity-panel">

          <div
            *ngIf="
              selectedContact?.participantsActivity &&
              selectedContact.participantsActivity.length > 0
            "
          >
            <div
              *ngFor="let participant of selectedContact.participantsActivity"
              class="participant-item"
            >
              <div class="participant-name">{{ participant.userName }}</div>
              <div class="participant-date">
                {{ participant.lastActivityDate | date : "dd.MM.yyyy HH:mm" }}
              </div>
            </div>
          </div>

          <div
            *ngIf="
              !selectedContact?.participantsActivity ||
              selectedContact.participantsActivity.length === 0
            "
            class="no-participants"
          >
            {{ "translate.chat.noParticipantActivity" | translate }}
          </div>
        </div>
      </p-popover>

      <order-chat
        *ngFor="let c of chatTabs"
        [hidden]="c.contact != (currentChatContact$ | async)"
        [contact]="c.contact"
        [order]="currentOrder"
        [disabled]="chatDisabled"
        (onCreateTask)="createChatTask($event)"
        (onFirstMessagesLoaded)="onFirstMessagesLoaded(c.contact)"
      ></order-chat>
    </div>

    <!--tasks-->
    <loader *ngIf="displayChatTasks && chatTasksLoading"></loader>
    <chat-tasks
      *ngIf="displayChatTasks"
      [order]="currentOrder"
      (onEditTask)="editChatTask($event)"
      (onCreateTask)="createTask()"
    ></chat-tasks>

    <!--notes-->
    <order-notes
      #notesCmp
      *ngIf="displayNotes"
      [order]="currentOrder"
      (onCreateNote)="onNoteAdded()"
    >
    </order-notes>

    <!--emails-->
    <order-emails
      *ngIf="displayEmails"
      [order]="currentOrder"
      (onUpdEmail)="onEmailsUpdated()"
    >
    </order-emails>
  </div>
</div>
